import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StudentSidebar } from 'constant';
import Header from 'components/header';
import { updateUser } from 'reducers/user';
import { IsMeetingEnabled } from 'utils/verify-meeting-access';
import { Query } from 'react-apollo';
import Spin from 'components/common/Spin';
import moment from 'moment';
import { toUserTimezone } from 'utils';
import { useHistory } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';
import { Box, Button, Typography } from '@material-ui/core';
import { GET_STATUSES } from 'graphql/student/stats';

const MENU_ITEMS = [
  { label: 'Account Settings', to: '/profile/account' },
  { label: 'General Info', to: '/profile/general' },
  { label: 'School Info', to: '/profile/school' },
  { label: 'College Questions', to: '/profile/college' },
  { label: 'Parent/Guardian Info', to: '/profile/guardian' },
  { label: 'Notification Settings', to: '/profile/settings' },
];

const Navigation = ({ showChat, toggleChat, toggleMenu }) => {
  const user = useSelector((s) => s.user.user);
  const profile = useSelector((s) => s.student.profile);
  const dispatch = useDispatch();
  const isMeetingEnable = IsMeetingEnabled(profile.user_id)
  const history = useHistory();

    React.useEffect(() => {
      dispatch(updateUser({
        isMeetingEnable
      }));
    },[isMeetingEnable])

  let meetingUrl = `/meeting/${user.sub}`;
  if (profile.product_type === 'group') {
    if (profile.group) {
      meetingUrl = `/meeting/group/${profile.group.group_id}`;
    }
  }

  return (
    <>
    <Query
                query={GET_STATUSES}
                variables={{ userId: user.id, sub: user.sub }}
                fetchPolicy={'cache-and-network'}
              >
                {({ data, loading }) => {
                  if (!data) return <Spin spinning />;
                  const currentDate = moment().format('YYYY-MM-DD');
                  const expirationDate = moment(
                    toUserTimezone(data.subscriptions[0].end_date),
                  ).format('YYYY-MM-DD');
                  const programEndDate = moment(expirationDate).diff(
                    currentDate,
                    'days',
                  );


                  const redirectToAddons = () => {
                    history.push('/addons');
                  }

                  return (
                    <Box p={2}>
                      {programEndDate !== null &&
                        programEndDate <= 30 &&
                        programEndDate > 1 && (
                          <Alert severity="warning"
                          action={
                            <Button  onClick={()=>redirectToAddons() }  color="secondary" variant="outlined"size="small">
                             Add on
                            </Button>
                          }>
                            <Typography color="secondary" variant="smallBold">
                              Your program ends in {programEndDate} days please
                              add-on and renew your program.
                            </Typography>
                          </Alert>
                        )}
                      {programEndDate <= 0 && (
                        <Alert severity="warning"
                        action={
                          <Button  onClick={()=>redirectToAddons() } color="secondary" variant="outlined"size="small">
                            Upgrade
                          </Button>
                        }>
                        <Typography color="secondary" variant="smallBold">
                          Your program has ended. please Upgrade and renew your program.
                        </Typography>
                       

                        
                        </Alert>
                      )}
                    </Box>
                  );
                }}
              </Query>
      <Header
      showNotifications
      routes={StudentSidebar}
      showChat={showChat}
      toggleChat={toggleChat}
      toggleMenu={toggleMenu}
      dropdownItems={MENU_ITEMS}
      meetingUrl={meetingUrl}
      isMeetingEnable={isMeetingEnable}
      />
      </>
  );
};

export default Navigation;
